import * as React from "react";
import { Query, graphql } from "react-apollo";
import { Row, Col, Button } from "reactstrap";
import * as uuid from "uuid";
import { MdModeEdit, MdDeleteForever } from "react-icons/md";

// GraphQL
import GetCompanySites from "../../GraphQL/Queries/GetCompanySites";
import DeleteSite from "../../GraphQL/Mutations/DeleteSite";

// Presentation/UI
import Loader from "../../Components/Loader/DotLoader";
import Table from "../../Components/Table";
import GlobalModal from "../../Components/GlobalModal";
import DialogModal from "../../Components/DialogModal";

import EditSiteForm from "./EditSiteForm";

interface IProps {
  companyId: string;
  toastManager: any;
  mutate: any;
}

class AllSites extends React.Component<IProps> {
  state = {
    modal: false,
    dialogModal: false,
    loading: false,
    title: "Are you sure you want to delete this site?",
    site: {},
    siteId: null
  };

  // Close dialog modal
  closeDialogModal = (): void => {
    this.setState({
      dialogModal: false
    });
  };

  // Open dialog modal
  openDialogModal = (companySite: any): void => {
    const siteId = !companySite ? null : companySite.id;
    this.setState({
      dialogModal: true,
      siteId
    });
  };

  // Handle response
  handleResponse = (e: React.FormEvent<HTMLInputElement>): void => {
    e.preventDefault();
    this.setState({ loading: true });
    // delete site mutation
    const { companyId } = this.props;
    this.props
      .mutate({
        variables: {
          id: this.state.siteId
        },
        refetchQueries: [
          {
            query: GetCompanySites,
            variables: { id: companyId }
          }
        ]
      })
      .then((res: any) => {
        this.setState({ loading: false, siteId: null });
        this.closeDialogModal();
        this.toastNotification("Site deleted successfully");
      })
      .catch((err: any) => {
        console.log(err);
      });
  };

  // Close modal
  closeModal = (): void => {
    this.setState({
      modal: false
    });
  };

  // Open modal
  openModal = (site: object): void => {
    this.setState({
      modal: true,
      site
    });
  };

  // success notification
  toastNotification = (message: string) => {
    this.props.toastManager.add(message, {
      appearance: "success",
      autoDismiss: true
    });
  };

  render() {
    const { site } = this.state;
    const { companyId } = this.props;
    return (
      <Query query={GetCompanySites} variables={{ id: companyId }}>
        {({ loading, error, data }) => {
          if (loading) {
            return <Loader />;
          }
          if (error) {
            return <div>There was a problem loading the data</div>;
          }

          const sites = data.allSites;

          return (
            <Row>
              <GlobalModal
                toggleModal={this.closeModal}
                title="Edit Site"
                modalDisplay={
                  <EditSiteForm
                    notification={this.toastNotification}
                    closeModal={this.closeModal}
                    companyId={companyId}
                    site={site}
                  />
                }
                modal={this.state.modal}
              />
              <DialogModal
                modal={this.state.dialogModal}
                title={this.state.title}
                loading={this.state.loading}
                toggleModal={this.closeDialogModal}
                handleResponse={this.handleResponse}
              />
              <Col xs={12} md={12} lg={12}>
                <Table
                  data={sites}
                  columns={[
                    {
                      Header: "Name",
                      accessor: "name",
                      sortable: false,
                      filterable: false
                    },
                    {
                      Header: "Physical Address",
                      accessor: "physicalAddress",
                      sortable: false,
                      filterable: false
                    },
                    {
                      Header: "Region",
                      accessor: "region",
                      sortable: false,
                      filterable: false
                    },
                    {
                      id: uuid(),
                      Header: "",
                      accessor: (companySite: object) => {
                        return (
                          <Button
                            onClick={() => this.openModal(companySite)}
                            className="icon-btn icon-edit-btn"
                          >
                            <MdModeEdit color="#fff" size="1.35em" />
                          </Button>
                        );
                      },
                      sortable: false,
                      filterable: false
                    },
                    {
                      id: uuid(),
                      Header: "",
                      accessor: (companySite: object) => {
                        return (
                          <Button
                            onClick={() => this.openDialogModal(companySite)}
                            className="icon-btn icon-delete-btn"
                          >
                            <MdDeleteForever color="#fff" size="1.35em" />
                          </Button>
                        );
                      },
                      sortable: false,
                      filterable: false
                    }
                  ]}
                  defaultPageSize={5}
                  showPaginationTop={false}
                  showPaginationBottom={true}
                />
              </Col>
            </Row>
          );
        }}
      </Query>
    );
  }
}

export default graphql<any, Response, any, any>(DeleteSite)(AllSites);



// WEBPACK FOOTER //
// ./src/Containers/Sites/AllSites.tsx